var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InsideContent',{attrs:{"title":_vm.$t('APP.STATS_BUILDER.ACTIVE_INSTALLS')}},[_c('Card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('AppChart',{attrs:{"options":_vm.chartOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }